class ApiService {
  static async fetchGeoData() {
    const cacheKey = 'geoData';
    const cachedData = sessionStorage.getItem(cacheKey);

    if (cachedData) {
      return JSON.parse(cachedData);
    }

    try {
      const response = await fetch('https://ipapi.co/json/');
      if (!response.ok) {
        throw new Error('Failed to fetch GeoData');
      }
      const data = await response.json();
      sessionStorage.setItem(cacheKey, JSON.stringify(data)); // Cache the response in sessionStorage
      return data;
    } catch (error) {
      console.error('Error fetching GeoData:', error);
      throw error;
    }
  }
}

class Config {
  static countryLatLong = [
    { latitude: 34.6037, longitude: 58.3816, place: 'AR', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/dcd0178b83005514.svg', url:'https://www.archiesfootwear.store/en-ar' },
    { latitude: 15.7801, longitude: 47.9292, place: 'BR', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/42137cee8a7b9c66.svg', url:'https://www.archiesfootwear.store/en-br' },
    { latitude: 33.4489, longitude: 70.6693, place: 'CL', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/3e2404d2110b3faa.svg', url:'https://www.archiesfootwear.store/en-cl' },
    { latitude: 22.2793, longitude: 114.1628, place: 'HK', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/399a7fea28e7dbdd.svg', url:'https://www.archiesfootwear.store/en-hk' },
    { latitude: 6.1751, longitude: 106.8650, place: 'ID', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/af8ae4bcec649b47.svg', url:'https://www.archiesfootwear.store/en-id' },
    { latitude: 3.1390, longitude: 101.6869, place: 'MY', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/61c2580145b4f1fd.svg', url:'https://www.archiesfootwear.store/en-my' },
    { latitude: 19.4326, longitude: 99.1332, place: 'MX', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/1f8c761e967280db.svg', url:'https://www.archiesfootwear.store/en-mx' },
    { latitude: 12.0464, longitude: 77.0428, place: 'PE', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/0e5601aa50fdf7ab.svg', url:'https://www.archiesfootwear.store/en-pe' },
    { latitude: 14.5995, longitude: 120.9842, place: 'PH', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/a9fffb4349bf3895.svg', url:'https://www.archiesfootwear.store/en-ph' },
    { latitude: 26.2041, longitude: 28.0473, place: 'ZA', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/28f06828821a680c.svg', url:'https://www.archiesfootwear.store/en-za' },
    { latitude: 25.0330, longitude: 121.5654, place: 'TW', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/43cab6eeab4df0b2.svg', url:'https://www.archiesfootwear.store/en-tw' },
    { latitude: 13.7563, longitude: 100.5018, place: 'TH', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/ffe662e5a63774ff.svg', url:'https://www.archiesfootwear.store/en-th' },
    { latitude: 16.0544, longitude: 108.2022, place: 'VN', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/ec619b52440b5ba5.svg', url:'https://www.archiesfootwear.store/en-vn' },
    { latitude: 59.9139, longitude: 10.7522, place: 'NO', image: 'https://cdn.shopify.com/s/files/1/1993/4531/files/Flag_of_Norway_430x.svg?v=1690101256', url:'https://archiesfootwear.eu' },
    { latitude: 50.04606, longitude: 15.2551, place: 'FR', image: 'https://cdn.shopify.com/s/files/1/1993/4531/files/Flag_of_France.svg?v=1688968766', url:'https://archiesfootwear.eu' },
    { latitude:52.520008, longitude:13.404954, place: 'DE', image: 'https://cdn.shopify.com/s/files/1/1993/4531/files/Flag_of_Germany.svg?v=1688968766', url:'https://archiesfootwear.de' },
    { latitude:52.370216, longitude:4.895168, place: 'NL', image: 'https://cdn.shopify.com/s/files/1/1993/4531/files/Flag_of_the_Netherlands.svg?v=1688968766', url:'https://archiesfootwear.eu' },
    { latitude:42.504154, longitude:12.646361, place: 'IT', image: 'https://cdn.shopify.com/s/files/1/1993/4531/files/Flag_of_Italy.svg?v=1688968766', url:'https://archiesfootwear.eu' },
    { latitude:40.416775, longitude:-3.703790, place: 'ES', image: 'https://cdn.shopify.com/s/files/1/1993/4531/files/Flag_of_Spain.svg?v=1688968766', url:'https://archiesfootwear.eu' },
    { latitude:43.651070, longitude:-79.347015, place: 'CA', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/422898ab4299eb270f856e6c1b8d2250.svg', url:'https://ca.archiesfootwear.com' },
    { latitude:44.500000, longitude:-89.500000, place: 'US', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/7f0109d94c888a663452af48e2d324d7.svg', url:'https://archiesfootwear.com' },
    { latitude: -36.848461, longitude: 174.763336, place: 'NZ', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/cacb9f87701ae2707676064d036a97b2.svg', url:'https://www.archiesfootwear.co.nz' },
    { latitude: 35.2809, longitude: 149.1300, place: 'AU', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/d4e9cde3edb3e1732ec50170e158d750.svg', url:'https://archiesfootwear.com.au' },
    { latitude: 51.509865, longitude: -0.118092, place: 'GB', image: 'https://cdn.shopify.com/shopifycloud/web/assets/v1/f9bbc4885a348eff84e4ef4155121fae.svg', url:'https://www.archiesfootwear.co.uk' }
  ];

  static EUCountries = [
    { code: 'DE', url: 'https://archiesfootwear.eu/de' },
    { code: 'FR', url: 'https://archiesfootwear.eu/fr' },
    { code: 'NL', url: 'https://archiesfootwear.eu/nl' }
  ];
}

class RedirectHandler {
  static async init() {
    try {
      const geoData = await ApiService.fetchGeoData();
      RedirectHandler.checkForRedirect(geoData);
    } catch (error) {
      console.error('Failed to initialize RedirectHandler:', error);
    }
  }

  static checkForRedirect(data) {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectParam = urlParams.get('redirect_country');

    if (redirectParam === 'true') {
      const { country_code: countryCode } = data;
      let targetLocation = Config.EUCountries.find((loc) => loc.code === countryCode) || 
                           Config.countryLatLong.find((loc) => loc.place === countryCode);

      if (targetLocation) {
        window.location.href = `${targetLocation.url}/pages/signup`;
      }
    }
  }
}

RedirectHandler.init();